export const mapSizesOptions = [
    'Small', 'Medium', 'Large', 'VeryLarge', 'Huge', 'FullScreen'
];